module.exports = __webpack_public_path__ + "img/shipo-map-bridge.3488fe00.svg";